
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const nomad: Operator = {
	id: 'nomad',
	name: 'Nomad',
	role: 'Attacker',
	org: 'GIGR',
	squad: 'WOLFGUARD',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 3
	},
	meta: {
		gender: 'f',
		country: 'ma',
		season: 'Y3S4',
		height: 171,
		weight: 63,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Sanaa El Maktoub',
		birthplace: 'Marrakesh, Morocco'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#a2794b"></path><path d="M106.722 146.778 45 111.056v19.167zM233.056 27l-16.195 25.778-16.111 55.236 28.833-53.347zm10.236 174.708L305 217.444v18.778zm-93.973 38.028-17.431 59.681-17.66 25.896 5.146-30.104z" style="fill:#fff"></path><path d="m205.666 226.137 75.823 55.29-55.262-75.734c5.408-8.962 8.522-19.463 8.522-30.693 0-11.238-3.119-21.746-8.533-30.712l55.22-75.705-75.787 55.271a59.2 59.2 0 0 0-30.4-8.354c-11.242 0-21.754 3.121-30.723 8.539l-75.888-55.4 55.461 75.968a59.2 59.2 0 0 0-8.35 30.394 59.2 59.2 0 0 0 8.333 30.364l-55.395 76.053 75.925-55.407c8.95 5.387 19.43 8.49 30.637 8.49a59.2 59.2 0 0 0 30.417-8.364"></path><circle cx="175.25" cy="175" r="51" style="fill:#fff"></circle><path d="m127.449 210.429-32.741 44.904 44.761-32.796a59.8 59.8 0 0 1-12.02-12.108" style="fill:#fff"></path><path d="m94.708 255.333 44.761-32.796-6.413-5.593z"></path><path d="m139.566 127.386-44.9-32.761 32.842 44.862a59.9 59.9 0 0 1 12.058-12.101" style="fill:#fff"></path><path d="M132.992 133.117 94.666 94.625l32.842 44.862a60 60 0 0 1 5.484-6.37"></path><path d="m222.879 139.337 32.51-44.781-44.792 32.585a59.8 59.8 0 0 1 12.282 12.196" style="fill:#fff"></path><path d="m217.11 132.724 38.279-38.168-44.792 32.585a60 60 0 0 1 6.513 5.583"></path><path d="m210.713 222.776 44.731 32.557-32.563-44.672a59.8 59.8 0 0 1-12.168 12.115" style="fill:#fff"></path><path d="m255.444 255.333-32.563-44.672a60 60 0 0 1-5.647 6.496z"></path><path d="M197.083 153.083 175 12.125l-22.083 140.958L12.278 175 153 197.222l22 140.556 22-140.556L337.722 175z"></path><path d="M191.333 158.958 175 56.667l-16.333 102.291-102.25 15.993L158.583 191 175 293.5 191.417 191l102.166-16.049z" style="fill:#fff"></path><path d="M175 175v118.5L191.417 191zm0 0-16.333-16.042L175 56.667zm0 0 16.333-16.042 102.25 15.993zm0 0-16.417 16-102.166-16.049z"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-nomad'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
